
export default function emoji_html(tokens, idx /*, options, env */) {
  return tokens[idx].content;
}
